import { useAppSelector } from "../../../../shared/hooks/useAppSelector";
import { uploadFileProgressSelector } from "../../../model";

import type { FC, ReactNode } from "react";

import styles from "./FileUploadProgress.module.scss";

interface FileUploadProgressProps {
    children: ReactNode;
}

export const FileUploadProgress: FC<FileUploadProgressProps> = ({ children }) => {
    const progress = useAppSelector(uploadFileProgressSelector);

    return (
        <div className={styles.progress}>
            <div className={styles.back}>
                {children}
            </div>
            <div className={styles.front} style={{ clipPath: `inset(0 0 0 ${progress ?? 0}%)` }}>
                {children}
            </div>
        </div>
    )
}
